/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdStudentDataMutationRequest,
  PutApiV1PersonIdStudentDataMutationResponse,
  PutApiV1PersonIdStudentDataPathParams,
  PutApiV1PersonIdStudentData400,
  PutApiV1PersonIdStudentData401,
  PutApiV1PersonIdStudentData404,
  PutApiV1PersonIdStudentData500,
} from "../../types/personStudentController/PutApiV1PersonIdStudentData.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdStudentData } from "../../clients/personStudentController/putApiV1PersonIdStudentData.ts";

export const putApiV1PersonIdStudentDataMutationKey = () =>
  [{ url: "/api/v1/person/:id/student-data" }] as const;

export type PutApiV1PersonIdStudentDataMutationKey = ReturnType<
  typeof putApiV1PersonIdStudentDataMutationKey
>;

export function putApiV1PersonIdStudentDataMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PutApiV1PersonIdStudentDataMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = putApiV1PersonIdStudentDataMutationKey();
  return mutationOptions<
    PutApiV1PersonIdStudentDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdStudentData400
      | PutApiV1PersonIdStudentData401
      | PutApiV1PersonIdStudentData404
      | PutApiV1PersonIdStudentData500
    >,
    {
      id: PutApiV1PersonIdStudentDataPathParams["id"];
      data?: PutApiV1PersonIdStudentDataMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdStudentData(id, data, config);
    },
  });
}

/**
 * @description Atualiza parcialmente a aba Student. Cria o vínculo de Student caso ainda não exista. Campos Ra e CodeUsp preservam o valor atual quando não informados (null-skip); demais campos sobrescrevem. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados de aluno (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/student-data}
 */
export function usePutApiV1PersonIdStudentData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdStudentDataMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdStudentData400
        | PutApiV1PersonIdStudentData401
        | PutApiV1PersonIdStudentData404
        | PutApiV1PersonIdStudentData500
      >,
      {
        id: PutApiV1PersonIdStudentDataPathParams["id"];
        data?: PutApiV1PersonIdStudentDataMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdStudentDataMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdStudentDataMutationKey();

  const baseOptions = putApiV1PersonIdStudentDataMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdStudentDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdStudentData400
      | PutApiV1PersonIdStudentData401
      | PutApiV1PersonIdStudentData404
      | PutApiV1PersonIdStudentData500
    >,
    {
      id: PutApiV1PersonIdStudentDataPathParams["id"];
      data?: PutApiV1PersonIdStudentDataMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdStudentDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdStudentData400
      | PutApiV1PersonIdStudentData401
      | PutApiV1PersonIdStudentData404
      | PutApiV1PersonIdStudentData500
    >,
    {
      id: PutApiV1PersonIdStudentDataPathParams["id"];
      data?: PutApiV1PersonIdStudentDataMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdStudentDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdStudentData400
      | PutApiV1PersonIdStudentData401
      | PutApiV1PersonIdStudentData404
      | PutApiV1PersonIdStudentData500
    >,
    {
      id: PutApiV1PersonIdStudentDataPathParams["id"];
      data?: PutApiV1PersonIdStudentDataMutationRequest;
    },
    TContext
  >;
}
